const PRODUCTION_ORIGIN = "https://www.andrewleger.com";

/**
 * Public origin for canonical links, Open Graph URLs, and JSON-LD.
 * Set NEXT_PUBLIC_BASE_URL in each environment. Production is
 * https://www.andrewleger.com when the variable is unset.
 */
export function resolveSiteBaseUrl(raw = process.env.NEXT_PUBLIC_BASE_URL): string {
  const configured = raw?.trim();
  if (!configured) return PRODUCTION_ORIGIN;
  return configured.replace(/\/+$/, "");
}

/**
 * Origin to send a buyer back to. A preview stays on its own branch URL,
 * because NEXT_PUBLIC_BASE_URL points every environment at production.
 */
export function resolveCheckoutBaseUrl(env: NodeJS.ProcessEnv = process.env): string {
  const branchUrl = env.VERCEL_BRANCH_URL?.trim();
  if (env.VERCEL_ENV === "preview" && branchUrl) return `https://${branchUrl}`;
  return resolveSiteBaseUrl();
}

export const baseUrl: string = resolveSiteBaseUrl();

export const siteBaseUrl: URL = new URL(baseUrl);
